export default "__VITE_ASSET__qqyn0TiJ__"